import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase/config";

async function userDocByUid(uid) {
  const snap = await getDocs(
    query(collection(db, "users"), where("uid", "==", uid))
  );
  if (snap.empty) return null;
  return { id: snap.docs[0].id, data: snap.docs[0].data() };
}

/**
 * On order confirm: move Points Earnings share into royaltyBalance (Cash).
 */
export async function applyCashRoyaltyTransferFromOrder(
  buyerId,
  transfer,
  cartOrderId
) {
  if (!transfer?.enabled) {
    return { success: true, skipped: true };
  }
  if (transfer.status === "completed") {
    return { success: true, skipped: true, reason: "already_completed" };
  }

  const amt = Number(transfer.transferAmount) || 0;
  if (amt <= 0) {
    return { success: true, skipped: true };
  }

  const user = await userDocByUid(buyerId);
  if (!user) {
    return { success: false, error: "User not found" };
  }

  const commissionBalance = Number(user.data.commissionBalance) || 0;
  if (amt > commissionBalance) {
    return {
      success: false,
      error: `Insufficient Points balance for Cash Wallet transfer (need ₹${amt.toFixed(
        2
      )}, have ₹${commissionBalance.toFixed(2)})`,
    };
  }

  const royaltyBefore = Number(user.data.royaltyBalance) || 0;
  const royaltyAfter = royaltyBefore + amt;

  await updateDoc(doc(db, "users", user.id), {
    commissionBalance: commissionBalance - amt,
    commissionUsed: (Number(user.data.commissionUsed) || 0) + amt,
    royaltyBalance: royaltyAfter,
    royaltyEarned: (Number(user.data.royaltyEarned) || 0) + amt,
    updatedAt: new Date().toISOString(),
  });

  await addDoc(collection(db, "pointsRoyaltyTransfers"), {
    userId: buyerId,
    cartOrderId,
    amount: amt,
    transferPercentage: transfer.transferPercentage ?? null,
    fromWallet: "POINTS_EARNINGS",
    toWallet: "ROYALTY_BALANCE",
    royaltyBefore,
    royaltyAfter,
    status: "completed",
    createdAt: serverTimestamp(),
  });

  return {
    success: true,
    amount: amt,
    royaltyAfter,
  };
}
